<template>
  <div class="box">
    <div class="nav">
      <ul class="location">
        <li>
          <Dropdown placement="bottom-start">
            <a href="javascript:void(0)" class="location-box">
              <Icon type="ios-location" class="icon"></Icon> {{ city }}
            </a>
            <DropdownMenu slot="list">
              <div class="city">
                <v-distpicker
                  type="mobile"
                  province="上海市"
                  city="上海城区"
                  area="黄浦区"
                  @selected="select"
                ></v-distpicker>
              </div>
            </DropdownMenu>
          </Dropdown>
        </li>
      </ul>
      <ul class="detail">
        <li class="first" v-show="!userInfo.nickname">
          你好，请<router-link to="/login">登录 </router-link> |<span
            class="text-color-red"
            ><router-link to="/SignUp">免费注册 </router-link></span
          >
        </li>
        <li v-show="!!userInfo.nickname">
          <Dropdown>
            <p class="username-p">
              <Avatar class="person-icon" icon="person" size="small" />
              <span class="username">{{ userInfo.nickname }} </span>
            </p>
            <DropdownMenu slot="list">
              <div class="my-page">
                <div class="my-info" @click="myInfo">
                  <Icon type="home" class="home-icon"></Icon>
                  <p>我的主页</p>
                </div>
                <div class="sign-out" @click="signOutFun">
                  <Icon type="log-out"></Icon>
                  <p>退出登录</p>
                </div>
              </div>
            </DropdownMenu>
          </Dropdown>
        </li>
        <li>
          <a href="javascript:void(0)" @click="goToPay">
            <Icon type="ios-cart-outline" class="cart"></Icon> 购物车
          </a>
        </li>
        <li><router-link to="/home/contactUs">联系我们</router-link></li>
        <li><router-link to="/freeback">意见反馈</router-link></li>
        <li><router-link to="/">商城首页</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { getCartList } from "@api/user";
import VDistpicker from "v-distpicker";
export default {
  name: "M-Header",
  components: {
    VDistpicker
  },
  watch: {
    userInfo() {
      // 判断是否登录，有登录需展示购物车
      if (Object.keys(this.userInfo).length > 0) {
        getCartList()
          .then(res => {
            this.SET_SHOPPING_CART(res.data.valid);
          })
          .catch(() => {
            // 间隔太久，需重新登录
            this.SIGN_OUT();
          });
      }
    }
  },
  created() {
    this.IS_LOGIN();
  },
  data() {
    return {
      city: "黄浦区"
    };
  },
  computed: {
    ...mapState(["userInfo", "shoppingCart"]),
    fourShoppingCart() {
      return this.shoppingCart.filter((item, index) => {
        return index < 5;
      });
    }
  },
  methods: {
    ...mapActions(["SIGN_OUT", "IS_LOGIN"]),
    ...mapMutations(["SET_SHOPPING_CART"]),
    changeCity(city) {
      this.city = city;
    },
    goToPay() {
      this.$router.push("/shoppingCart");
    },
    myInfo() {
      this.$router.push("/home");
    },
    signOutFun() {
      this.SIGN_OUT();
      this.$router.push("/");
    },
    select(index) {
      if (index.area.value !== "区") {
        this.city = index.area.value;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.box /deep/ .ivu-select-dropdown
  z-index 1000

.box
  width 100%
  height 35px
  background-color #f6f9f9
  border-bottom 1px solid #e6e6e6
  font-family "宋体"
  .nav
    margin 0 auto
    width 1200px
    display flex
    flex-direction row
    justify-content space-between
    ul
      list-style none
      li
        float left
        font-size 14px
        line-height 35px
        margin-right 15px
        &:last-child
          margin-right 0
        a
          text-decoration: none
          color #666
          padding-left 13px
          cursor pointer
          &.icon
            color #ff5145
            font-size 18px
            margin-right 3px
        .location-box
          padding-left 0
        .cart
          font-size 20px
          transform translateY(2px)
    .location
      color #666
      .icon
          color: #ff5145
          font-size 18px
      .city
        padding 10px 15px
        width 300px
        height 400px
        overflow-y auto

    .detail
      .first
        color #999
        a
          &:hover
            border-left none
        .text-color-red
          a
            color #ff5c4d
      .username-p
        cursor pointer
        .person-icon
          color #c7c7c7
          background-color #e1e1e1
          transform translateY(-1px)
        .username
          margin-left 5px
      .my-page
        padding 3px 5px
        width 180px
        height 100%
        display flex
        justify-content center
        align-items center
        .my-info
          padding 5px
          width 50%
          height 100%
          text-align center
          cursor pointer
          &:hover
            box-shadow 0px 0px 5px #ccc
          i
            font-size 28px
          p
            font-size 12px
        .sign-out
          padding 5px
          width 50%
          height 100%
          text-align center
          cursor pointer
          &:hover
            box-shadow 0px 0px 5px #ccc
          i
            font-size 28px
          p
            font-size 12px
</style>
